module.exports = __webpack_public_path__ + "img/forward-fill.66387c0e.svg";